// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import contractStatusEntity from './entities/contract-status.json';
import contractStatusMenu from '../pages/contract-status/menu.json';
import contractStatusFullForm from '../pages/contract-status/forms/full.json';
import contractStatusContextForm from '../pages/contract-status/forms/context.json';
import contractStatusMiniForm from '../pages/contract-status/forms/mini.json';
import contractStatusLookupForm from '../pages/contract-status/forms/lookup.json';
import contractStatusTableView from '../pages/contract-status/views/table.json';
import contractStatusDashboardView from '../pages/contract-status/views/dashboard.json';

/** Тип запису «Статус договору» зі сторінками пакета: меню, форми та подання з pages/contract-status/. */
export const contractStatusDefinition: IRecordTypeDefinition = {
  ...contractStatusEntity,
  views: assembleViewSet({
      table: contractStatusTableView,
      dashboard: contractStatusDashboardView,
  }),
  form: contractStatusFullForm,
  forms: { full: contractStatusFullForm, context: contractStatusContextForm, mini: contractStatusMiniForm, lookup: contractStatusLookupForm },
  menu: contractStatusMenu,
} as IRecordTypeDefinition;
